import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { useGenericCurvedRow } from './use-generic-curved-row';
export const GenericCurvedRow = React.memo((props) => {
    const { definition, realAngle, dataHook = '', reverse = false } = props;
    const { labels, getCurveSeatPosition } = useGenericCurvedRow(props);
    const { Seat } = useContext(ComponentContext);
    const renderSeats = () => labels.map((label, index) => {
        const seatIndex = reverse ? labels.length - index - 1 : index;
        const position = getCurveSeatPosition(index);
        return (React.createElement(Seat, { x: position.x, y: position.y, definition: { ...definition, angle: realAngle }, label: label, key: label, realAngle: realAngle, index: seatIndex }));
    });
    return React.createElement("svg", { "data-hook": dataHook }, renderSeats());
});
//# sourceMappingURL=generic-curved-row.js.map